import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { recentlyViewedListSelector, isRecentlyViewedLoadingSelector } from '../../../../customer/redux/cart/cart.selectors';
import RecentlyViewedWidgetComponent from './recently-viewed-widget';
const mapStateToProps = createStructuredSelector({
  recentlyViewedList: recentlyViewedListSelector,
  isRecentlyViewedLoading: isRecentlyViewedLoadingSelector
});
export const RecentlyViewedWidget = connect(mapStateToProps)(RecentlyViewedWidgetComponent);